.section {
  padding-bottom: 15px;
  padding-top: 10px;
}
